import React, { useState, useEffect } from 'react'
import { Button, Modal } from '../../atoms'
import { SESSION_EXPIRED_EVENT } from '@pepper/utils/src/function/event'

import { useAuthState } from '../../providers'

export function SessionExpiredModal(): JSX.Element {
  const [isSessionExpired, setIsSessionExpired] = useState(false)
  const { logout } = useAuthState()

  useEffect(() => {
    // Here, we're listening for SESSION_EXPIRED_EVENT to be dispatch
    // once event dispatched then we display session expire modal to user.
    // and remove event listener on useEffects cleanup
    document.addEventListener(SESSION_EXPIRED_EVENT.type, () => {
      setIsSessionExpired(true)
    })

    return function () {
      document.removeEventListener(SESSION_EXPIRED_EVENT.type, () => {
        setIsSessionExpired(false)
      })
    }
  }, [isSessionExpired])

  return (
    <Modal
      visible={isSessionExpired}
      centered={true}
      title="Session Expired. Log in again!"
      footer={
        <Button
          type="primary"
          onClick={function () {
            logout()
            window.location.replace('/login')
          }}
        >
          Okay
        </Button>
      }
    >
      Looks like your session has expired. Click Okay to return to page.
    </Modal>
  )
}
